module.exports = "varying vec2 _uv;\nvoid main(void){\n    _uv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);\n}\n";
